import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-piechart',
  templateUrl: './piechart.component.html',
  styleUrls: ['./piechart.component.scss']
})
export class PiechartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
